module.exports = {"450110100":"城厢镇","450110102":"太平镇","450110103":"双桥镇","450110104":"宁武镇","450110105":"锣圩镇","450110106":"仙湖镇","450110107":"府城镇","450110108":"陆斡镇","450110109":"两江镇","450110110":"罗波镇","450110111":"灵马镇","450110112":"甘圩镇","450110113":"马头镇","450110451":"南宁华侨投资区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450110.json
// module id = 2075
// module chunks = 0